import { render, staticRenderFns } from "./customer.select.vue?vue&type=template&id=18e147de&scoped=true&"
import script from "./customer.select.vue?vue&type=script&lang=js&"
export * from "./customer.select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e147de",
  null
  
)

export default component.exports